import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"margin-bottom":"20px","text-align":"right"}
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("上传文件")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("创建文档")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 预 览 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("创建")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("关闭")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode(" 拖动文件到此处"),
  /*#__PURE__*/_createElementVNode("em", null, "上传")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, " 允许上传文件类型：pdf文档,office文档,图像(jpg,jpeg,bmp) ", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("关闭")

import { reactive, ref, PropType, watch, unref } from 'vue';
import { useRouter } from 'vue-router'

import moment from 'moment';
import { ElMessage, ElMessageBox, ElForm, UploadUserFile, UploadFile, FormRules } from 'element-plus';

/* Plugins */
import { GbTables } from '@/components/GbTables'
import { GbDialog } from '@/components/GbDialog/Index';
import { TableColumn } from '@/components/GbTables/GbTablesTypes'
import { useAppStore } from '@/store/app'

/* Helpers */
import { config } from '@/config/config'
import { findIndex } from '@/utils';
import { propTypes } from '@/utils/propTypes'

/* Types */
import { AttachmentDetail } from '@/apis/attachment/attachment.type'
import { FileUploadDto, CreateDocDto } from '../../../apis/attachment/attachment.type';

/* 数据类型/API */
import { GetAttachmentList, DelAttachmentApi } from '@/apis/attachment/attachment.api'
import { GetFileType } from '../../../helpers/statusHelpers';
import { CreateDocApi } from '../../../apis/attachment/attachment.api';
import { validate } from '@babel/types';


export default /*#__PURE__*/_defineComponent({
  props: {
    isPreviews: propTypes.bool.def(false),
},
  setup(__props, { expose }) {

const props = __props




const { base_url } = config
const { resolve } = useRouter()
const login = useAppStore().getLoginInfo

const loading = ref(false);
const showDialog = ref(false);
const showInsDialog = ref(false);

const actionUrl = `${base_url}/api/onlyofficeapi/uploadfile`;
const fileList = ref<AttachmentDetail[]>([]);
const ufileList = ref<UploadUserFile[]>([])

const gbTablesRef = ref<ComponentRef<typeof GbTables>>()
const elFormDocRef = ref<ComponentRef<typeof ElForm>>()

/* 文档表单数据 */
const folderId = ref<number>(0);
const docSchema = ref<CreateDocDto>({ doc_title: '', doc_type: 'D647F9B7-F230-4BF0-9766-F295FFA32AF0', contract_id: '' })
const uploadData = ref<FileUploadDto>({ contract_id: '', upload_user: login.user_name, file_type: '65CAF56C-0CD8-49C2-ACA5-A5B8FE4DB3CE' })

const tabColumns = reactive<TableColumn[]>([
    { field: 'file_name', label: '文件名称' },
    { field: 'content_length', label: '文件大小', columnWidth: "100" },
    { field: 'file_type', label: '文件类型', columnWidth: "100", align: 'center' },
    { field: 'upload_user', label: '上传用户', columnWidth: "100" },
    { field: 'created_time', label: '上传时间', columnWidth: "150px", fixed: 'right' },
    { field: 'action', width: '180px', label: "操作", fixed: 'right', align: 'center' }
])

/* 表单验证规则 */
const formRules = reactive<FormRules>({
    doc_title: [{ required: true, message: '文档名称不能留空', trigger: 'blur' },],
    doc_type: [{ required: true, message: '请选择文档类型', trigger: 'blur' },],
})

/* 上传的请求头 */

const upHeaders = ref<Record<string, string>>({ "Authorization": `Bearer ${login.token}` })

const actions = {
    showPreview: (row: any) => {
        return row.can_open ? true : false
    }
}

/* 从接口读取文档列表 */
const getFileListApi = (ctId: string) => {
    if (!ctId) return
    loading.value = true
    GetAttachmentList(ctId).then(res => {
        if (!res.succeeded) {
            ElMessage.error(`获取文档列表失败，原因：${res.errors}。`);
        }
        else {
            fileList.value = res.data.data
        }
        loading.value = false;
    });
}

/* 创建Doc文档 */
const createDoc = () => {
    unref(elFormDocRef)?.validate((isVail: boolean) => {
        if (!validate) return
        loading.value = true
        CreateDocApi(docSchema.value).then(res => {
            if (!res.succeeded) {
                ElMessage.error(`创建文档失败，可能的原因是：${res.errors}`)
            }
            else {
                fileList.value.push(res.data);
                showInsDialog.value = false;
                docSchema.value.doc_title = ''
            }

        }).finally(() => { loading.value = false })
    })
};

/* 删除文档 */
const deleteFile = (file: AttachmentDetail) => {
    const rowIndex = findIndex<AttachmentDetail>(fileList.value, (t: AttachmentDetail) => { return t.id == file.id })
    if (rowIndex < 0) return;

    ElMessageBox.confirm("是否删除选中的数据？", "提示", { confirmButtonText: "确定", cancelButtonText: "取消", type: 'warning', lockScroll: false })
        .then(async () => {

            await DelAttachmentApi(file.id).then(res => {

                if (!res.succeeded) {

                    ElMessage.error(`附件删除失败，原因：${res.errors}`);

                }
                else {

                    ElMessage.success(`删除成功。`);

                    fileList.value.splice(rowIndex, 1)

                }

            });
        })
}

/* 上传成功 */
const onUploadSuccess = (res: IResponse, file: UploadFile) => {
    if (!res.succeeded) {
        ElMessage.error(`文件上传失败，可能的原因是：${res.errors}`)
    } else {
        folderId.value = res.data.folder_Id;
        fileList.value.push(res.data.file);
        docSchema.value.doc_title = ''
        ElMessage.success("上传成功")
    }
};

/* 文档预览/编辑 */
const docOpenAction = (docId: string, action: string) => {
    let urls = resolve({ path: `/document/${action}`, query: { fileId: docId } })
    window.open(urls.href, "_blank")
}

const methods: {
    setDatas: (contractId: string) => void
    getFiles: () => string[]
} = {

    /* 获取新增文档Id列表(TypeId为Null) */
    getFiles: (): string[] => {

        const fileIds: string[] = fileList.value
            .filter((mt: AttachmentDetail) => { return mt.type_id == "" || mt.type_id == null || mt.type_id == undefined })
            .map((mt: AttachmentDetail) => {
                return mt.id
            })

        return fileIds;
    },

    /* 设置文件数据列表  */
    setDatas: (contractId: string) => {
        getFileListApi(contractId)
        uploadData.value.contract_id = contractId || ''
        docSchema.value.contract_id = contractId || ''
    }
}

expose({ gbTablesRef, methods })

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ElButton = _resolveComponent("ElButton")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_upload_filled = _resolveComponent("upload-filled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!props.isPreviews)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showDialog.value = true))
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (showInsDialog.value = true))
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(GbTables), {
      ref_key: "gbTablesRef",
      ref: gbTablesRef,
      columns: _unref(tabColumns),
      data: fileList.value,
      showPaged: false
    }, {
      file_type: _withCtx(({ row }) => [
        _createElementVNode("span", null, _toDisplayString(_unref(GetFileType)(row.file_type)), 1)
      ]),
      created_time: _withCtx(({ row }) => [
        _createElementVNode("span", null, _toDisplayString(_unref(moment)(row.created_time).format('YYYY-MM-DD HH:mm')), 1)
      ]),
      action: _withCtx(({ row }) => [
        _withDirectives(_createVNode(_component_ElButton, {
          type: "primary",
          link: "",
          onClick: ($event: any) => (docOpenAction(row.file_id, 'previews'))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 2
        }, 1032, ["onClick"]), [
          [_vShow, actions.showPreview(row)]
        ]),
        (!props.isPreviews && row.can_open)
          ? (_openBlock(), _createBlock(_component_ElButton, {
              key: 0,
              type: "success",
              link: "",
              onClick: ($event: any) => (docOpenAction(row.file_id, 'editor'))
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 2
            }, 1032, ["onClick"]))
          : _createCommentVNode("", true),
        (!props.isPreviews)
          ? (_openBlock(), _createBlock(_component_ElButton, {
              key: 1,
              type: "danger",
              link: "",
              onClick: ($event: any) => (deleteFile(row))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 2
            }, 1032, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["columns", "data"]),
    _createVNode(_unref(GbDialog), {
      modelValue: showInsDialog.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showInsDialog).value = $event)),
      title: "创建文档（Word文档）",
      style: {"width":"500px"}
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          disabled: loading.value,
          onClick: createDoc
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "info",
          disabled: loading.value,
          onClick: _cache[4] || (_cache[4] = ($event: any) => (showInsDialog.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(ElForm), {
          model: docSchema.value,
          ref_key: "elFormDocRef",
          ref: elFormDocRef,
          rules: _unref(formRules),
          "label-width": "100px",
          "label-position": 'right'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "文档名称",
              prop: "doc_title"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: docSchema.value.doc_title,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((docSchema.value.doc_title) = $event)),
                  placeholder: "请输入文档名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "文件类型",
              prop: "doc_type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: docSchema.value.doc_type,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((docSchema.value.doc_type) = $event)),
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "合同正文",
                      value: "65CAF56C-0CD8-49C2-ACA5-A5B8FE4DB3CE"
                    }),
                    _createVNode(_component_el_option, {
                      label: "其他",
                      value: "D647F9B7-F230-4BF0-9766-F295FFA32AF0"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_unref(GbDialog), {
      modelValue: showDialog.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((showDialog).value = $event)),
      title: "上传文件",
      style: {"width":"500px"}
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "info",
          disabled: loading.value,
          onClick: _cache[8] || (_cache[8] = ($event: any) => (showDialog.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(ElForm), {
          model: uploadData.value,
          "label-width": "100px",
          "label-position": 'right'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "文件类型",
              prop: "file_type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: uploadData.value.file_type,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((uploadData.value.file_type) = $event)),
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "合同正文",
                      value: "65CAF56C-0CD8-49C2-ACA5-A5B8FE4DB3CE"
                    }),
                    _createVNode(_component_el_option, {
                      label: "其他",
                      value: "D647F9B7-F230-4BF0-9766-F295FFA32AF0"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createVNode(_component_el_upload, {
          "file-list": ufileList.value,
          "onUpdate:file-list": _cache[7] || (_cache[7] = ($event: any) => ((ufileList).value = $event)),
          drag: "",
          multiple: "",
          data: uploadData.value,
          action: actionUrl,
          headers: upHeaders.value,
          "on-success": onUploadSuccess
        }, {
          tip: _withCtx(() => [
            _hoisted_10
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
              default: _withCtx(() => [
                _createVNode(_component_upload_filled)
              ]),
              _: 1
            }),
            _hoisted_9
          ]),
          _: 1
        }, 8, ["file-list", "data", "headers"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})